import React from 'react'
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import FavoriteIcon from '@mui/icons-material/Favorite';
import NearMeIcon from '@mui/icons-material/NearMe';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import './influencerCard.css'
const influencerCard = (props)=> {
    let {username,Name,profileImg,Img,commentCount,likesCount} = props;
    return(
        <div className='ic-outer'>
            <img className='ic-pimage' src={profileImg}></img>
            <div className='ic-username'>
                <b>{Name}</b><br/>
                @{username}
            </div>
            <div className='ic-inner'>
                <img className='ic-post' src={Img}></img>
            </div>
            <div className='ic-footer'>
                <ChatBubbleIcon className='ic-comments' sx={{ color: 'white' }}/>
                <span className='ic-commentCount'>10</span>
                <FavoriteIcon className='ic-likes' sx={{ color: 'white' }}/>
                <span className='ic-likesCount'>122</span>
                <NearMeIcon className='ic-message' sx={{ color: 'white' }}/>
                <SaveAltIcon className='ic-saved' sx={{ color: 'white' }}/>
            </div>
        </div>
    )
}

export default influencerCard